module.exports = __webpack_public_path__ + "img/24.8207c742.png";